<template lang="pug">
div
  v-row
    v-col(cols="12" md="6")
      .d-flex.align-center
        template(v-if="isEditingTitle")
          v-form(ref="form")
            yc-text-field.mr-2(label="Segment name" v-model="editedName" :rules="rules.not_empty" validate-on-blur)
          v-btn.mr-2.button-Aa-medium(@click="isEditingTitle = false" color="info" height=40 :loading="isLoading" depressed) {{ $t('save') }} 
          v-btn.button-Aa-medium(@click="cancelName" color="primary400" height=40 text) {{ $t('cancel') }}
        template(v-else)
          h5.mr-2 {{ editedName }}
          v-btn(@click="editSegmentName" color="primary400" icon)
            v-icon(small) $yzi-edit-02
      .mt-2
        template(v-if="isEditingDescription")
          yc-text-field.mr-2.mb-2(label="Description" v-model="editedDescription")
          v-btn.mr-2.button-Aa-medium(@click="isEditingDescription = false" color="info" height=40 depressed) {{ $t('save') }} 
          v-btn.button-Aa-medium(@click="cancelDescription" color="primary400" height=40 text) {{ $t('cancel') }}
        template(v-else)
          .text-sm.font-normal.primary400--text {{ editedDescription || 'No description' }}
            span
              v-btn(@click="editSegmentDescription" color="primary400" icon)
                v-icon(small) $yzi-edit-02
    v-col.d-flex.align-center(cols="12" md="6" v-if="!isMobileScreen")
      v-spacer
      v-btn.button-md.neutral500--text.mr-2(text @click="back") {{ $t('back_to_customers_page') }}
      v-btn.button-md(@click="finish" color="info" dark depressed :loading="isLoading") {{ $t('finish') }}
  .mt-4.text-md {{ customers.length }} {{ $t('customers_selected_from_list') }}
  v-data-table.mt-4(:headers="headers" :items="customers" :items-per-page="customers.length" :hide-default-header="isMobileScreen" item-key="id" hide-default-footer disable-sort)
    template(v-slot:item.created="{ item }")
      div {{ item.created | displayDate }}
    template(v-slot:item.name="{ item }")
      .font-medium {{ item.name }}
    template(v-if="isMobileScreen" v-slot:item="{ item }")
      .py-3.text-sm
        .font-medium.mb-2 {{ item.name }}
        .d-flex.mb-1
          .flex-grow-1
            .basic600--text {{ $t('phone_number') }}
          div {{ item.phone }}
        .d-flex.mb-1
          .flex-grow-1
            .basic600--text {{ $t('created_on') }}
          div {{ item.created | convertServerDate }}
      v-divider
  .yc-fixed-bottom-section(v-if="isMobileScreen")
    .d-flex.align-center
      v-btn.button-md(@click="back" color="neutral500" text) {{ $t('back') }}
      v-spacer
      v-btn.button-md(@click="finish" color="info" depressed) {{ $t('finish') }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: {
    os: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    customers: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isLoading: false,
    editedName: '',
    editedDescription: '',
    isEditingTitle: false,
    isEditingDescription: false,
    rules: {
      not_empty: [v => v.trim().length || 'This field is required']
    },
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Phone number', value: 'phone' },
      { text: 'Created on', value: 'created' }
    ],
    activeGroupCount: 0
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    ...mapState('subscriptions', ['connectSubscription']),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    }
  },
  created () {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchActiveGroupCount()
  },
  watch: {
    name (val) {
      this.editedName = val
    },
    description (val) {
      this.editedDescription = val
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    back () {
      this.$emit('onBack')
    },
    editSegmentName () {
      this.isEditingTitle = true
    },
    editSegmentDescription () {
      this.isEditingDescription = true
    },
    cancelName () {
      this.editedName = this.name
      this.isEditingTitle = false
    },
    cancelDescription () {
      this.editedDescription = this.description
      this.isEditingDescription = false
    },
    fetchActiveGroupCount () {
      this.$axios.get(`/connect/${this.company.slug}/settings`)
        .then(resp => {
          this.activeGroupCount = resp.data.active_group_count
        })
        .catch(() => {})
    },
    reachGroupCountLimit () {
      const maxCount = this.connectSubscription?.limitations?.segment || 0
      if (maxCount === -1 || this.activeGroupCount < maxCount || this.os !== 'connect') {
        return false
      }
      return true
    },
    finish () {
      this.isLoading = true
      const customerIds = this.customers.map(item => item.id)
      const params = {
        title: this.editedName,
        description: this.editedDescription,
        enabled: !this.reachGroupCountLimit(),
        customer: customerIds
      }
      this.$axios.post(`/connect/${this.company.slug}/groups`, params)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.segment_created_successfully')])
          this.$router.push(`/admin/${this.os}/segments`)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_create_segment')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
